import React, { Component } from "react";
import api from "../../../api/api";
import CookieHandler from "../../common/CookieHandler";
import DocChargeAdd from "./Documentation-Charges-Add";
import DocChargeView from "./Documentation-Charges-View";
import DocChargeUpdate from "./Documentation-Charges-Update";

import { Alert } from "@material-ui/lab";
import { Snackbar, TextField, Checkbox, Drawer } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import config from "../../../config/config";
import { withStyles } from "@material-ui/core/styles";
import DeleteConfirmation from "../../common/DeleteConfirmation";
import { pad, toLocaleString } from "../../common/common";
import Loader from "../../common/Loader";

const CheckBox = withStyles({
  root: {
    color: "#ccc",
    "&$checked": {
      color: config.themeColor,
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default class DocList extends Component {
  constructor(props) {
    super(props);
    this.Cookie = new CookieHandler();
    this.state = {
      doc_costing_barges: [],
      isLoading: true,
      business_no_drop_value: [],
      documentation_agent_drop_value: [],
      documentation_agent_ids: [],
      business_no_id: [],
      business_no_ids: [],
      deleteCosting: false,
      features: [],
      showDrawer: false,
      DocChargeAdd: false,
      DocChargeView: false,
      DocChargeUpdate: false,
      bargeCostingID: null,
      updateDocuments: false,
    };
  }

  async componentDidMount() {
    if (!this.Cookie.isLoggedIn()) {
      this.props.history.replace("/logout");
    }
    const features = this.Cookie.getCookie("features");
    this.setState({ features: features });
    if (!(features.includes("175") || features.includes("97"))) {
      window.location.href = "/dashboard";
    }
    const loginUserID = this.Cookie.getCookie("loginUserId");
    const idToken = this.Cookie.getIdTokenCookie();
    api.getBusinessNumbers(loginUserID, idToken).then((response) => {
      if (response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if (res.code === "200") {
            if (res.idtoken) this.Cookie.setIdTokenCookie(res.idtoken);
            if (res.business_numbers) {
              let business_no_drop_value = [];
              for (var i of res.business_numbers) {
                business_no_drop_value.push({
                  name: i.business_no,
                  value: i.id,
                  mother_vessel_name: i.mother_vessel_name,
                });
              }
              this.setState({
                business_no_drop_value: business_no_drop_value,
                loading: false,
              });
            } else {
              alert("Unexpected error occured. Please contact administrator.");
            }
          } else if (res.code === "607") {
            window.location.href = "/logout";
          }
        });
      }
    });
    // calling Vendors Api
    let status = "Active ";
    const vendorsDataResponse = await api.getVendors(
      loginUserID,
      idToken,
      status
    );
    if (vendorsDataResponse.status >= 200 && vendorsDataResponse.status < 300) {
      vendorsDataResponse.json().then((res) => {
        if (res.code === "200") {
          if (res.vendors) {
            const vendorAsOthers = [];
            for (var i of res.vendors) {
              if (i.vendor_type === "Others") {
                vendorAsOthers.push({
                  name: i.vendor_name,
                  value: i.id,
                  key: i,
                });
              }
            }
            this.setState({
              documentation_agent_drop_value: vendorAsOthers,
              isLoading: false,
            });
          } else {
            alert("Unexpected error occured. Please contact administrator.");
          }
        } else if (res.code === "607") {
          window.location.href = "/logout";
        }
      });
    }
  }

  searchBargeHandler() {
    this.setState({ isLoading: true });
    const loginUserID = this.Cookie.getCookie("loginUserId");
    const idToken = this.Cookie.getIdTokenCookie();
    let business_no = this.state.business_no_id;
    let documentation_agent = this.state.documentation_agent_ids;
    api
      .get_barges_for_doc_charges(
        loginUserID,
        idToken,
        business_no,
        documentation_agent
      )
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if (res.code === "200") {
              if (res.barges) {
                if (res.barges.length === 0) {
                  this.setState({
                    snackBarErrorOpen: true,
                    errorMsg: "No records to display",
                  });
                }
                this.setState({
                  doc_costing_barges: res.barges,
                  isLoading: false,
                });
              }
            } else if (res.code === "607") {
              window.location.href = "/logout";
            }
          });
        }
      });
  }

  delete_barge_pur_fin_doc_charges = (data) => {
    this.setState({ isLoading: true });
    var loginUserID = this.Cookie.getCookie("loginUserId");
    var idToken = this.Cookie.getIdTokenCookie();
    var doc_charges_id = data.id;
    api
      .delete_barge_doc_charges(loginUserID, idToken, doc_charges_id)
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if (res.code === "200") {
              window.$("#deleteConformationModal").modal("hide");
              window.$(".modal-backdrop").remove();
              this.setState(
                {
                  snackBarSuccessOpen: true,
                  successMsg: res.message,
                  deleteCosting: false,
                  isLoading: false,
                },
                () => {
                  this.searchBargeHandler();
                }
              );
            } else if (res.code === "601") {
              this.setState({
                snackBarErrorOpen: true,
                errorMsg: res.message,
                deleteCosting: false,
                isLoading: false,
              });
            } else if (res.code === "607") {
              window.location.href = "/logout";
            } else if (res.code === "624") {
              this.setState({
                snackBarErrorOpen: true,
                errorMsg: res.message,
                deleteCosting: false,
                isLoading: false,
              });
            } else if (res.code === "650") {
              window.$("#deleteConformationModal").modal("hide");
              window.$(".modal-backdrop").remove();
              this.setState({
                snackBarErrorOpen: true,
                deleteCosting: false,
                deleteErrorMsg:
                  "Payments are available for this record. Please delete Payments before deleting this record.",
                errorMsg:
                  "Payments are available for this record. Please delete Payments before deleting this record.",
                isLoading: false,
              });
            }
          });
        }
      });
  };

  onUpdateResponse = (value) => {
    if (value === "200") {
      this.setState({
        DocChargeUpdate: false,
        DocChargeAdd: false,
        DocChargeView: true,
        updateDocuments: false,
      });
    }
  };

  onAddResponse = (value) => {
    if (value === "200") {
      this.setState({
        DocChargeAdd: false,
        DocChargeView: false,
        showDrawer: false,
        updateDocuments: false,
      });
    }
  };

  onCancel = (value) => {
    if (value === false) {
      this.setState({
        DocChargeUpdate: false,
        DocChargeAdd: false,
        DocChargeView: false,
        showDrawer: false,
        bargeCostingID: null,
        updateDocuments: false,
      });
    }
  };
  onEdit = (value) => {
    if (value === true) {
      this.setState({
        showDrawer: true,
        DocChargeUpdate: true,
        DocChargeView: false,
        DocChargeAdd: false,
        updateDocuments: false,
      });
    }
  };

  addDocuments = () => {
    this.setState({
      showDrawer: true,
      DocChargeUpdate: true,
      DocChargeView: false,
      DocChargeAdd: false,
      updateDocuments: true,
    });
  };

  render() {
    let drawerComponent;
    if (this.state.DocChargeAdd) {
      drawerComponent = (
        <DocChargeAdd
          onAddResponse={this.onAddResponse}
          onCancel={this.onCancel}
        />
      );
    } else if (this.state.DocChargeView && this.state.bargeCostingID !== null) {
      drawerComponent = (
        <DocChargeView
          docID={this.state.bargeCostingID}
          returnDocumentsHandler={this.addDocuments}
          onCancel={this.onCancel}
          onEdit={this.onEdit}
        />
      );
    } else if (
      this.state.DocChargeUpdate &&
      this.state.bargeCostingID !== null
    ) {
      drawerComponent = (
        <DocChargeUpdate
          docID={this.state.bargeCostingID}
          onUpdateCosting={this.onUpdateResponse}
          onCancel={this.onCancel}
          updateDocuments={this.state.updateDocuments}
        />
      );
    }
    if (this.state.isLoading) {
      return <Loader />;
    } else {
      return (
        <div className="card mt-1">
          <Drawer
            anchor="right"
            open={this.state.showDrawer}
            variant="temporary"
            elevation={20}
            style={{ overflow: "initial" }}
          >
            <div className="row" style={{ width: 800 }}>
              {drawerComponent}
            </div>
          </Drawer>
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            open={this.state.snackBarErrorOpen}
            onClose={() => this.setState({ snackBarErrorOpen: false })}
            style={{ width: "450px" }}
          >
            <Alert
              elevation={6}
              variant="filled"
              onClose={() => this.setState({ snackBarErrorOpen: false })}
              severity="error"
              style={{ width: "100%" }}
            >
              {this.state.errorMsg}
            </Alert>
          </Snackbar>
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            style={{ width: "450px" }}
            open={this.state.snackBarSuccessOpen}
            autoHideDuration={100000}
            onClose={() => this.setState({ snackBarSuccessOpen: false })}
          >
            <Alert
              elevation={6}
              variant="filled"
              onClose={() => this.setState({ snackBarSuccessOpen: false })}
              severity="success"
              style={{ width: "100%" }}
            >
              {this.state.successMsg}
            </Alert>
          </Snackbar>
          <div className="row mb-1 p-2">
            <div className="col-lg-3 pt-3">
              <Autocomplete
                multiple
                options={this.state.business_no_drop_value}
                getOptionLabel={(option) => option.mother_vessel_name}
                renderOption={(option, { selected }) => (
                  <React.Fragment>
                    <CheckBox style={{ marginRight: 8 }} checked={selected} />
                    <div className="col-lg p-0 m-0">
                      <label className="form_label mb-0">
                        {option.mother_vessel_name}
                      </label>
                      <label
                        className="contract_display_header_value m-0 pl-0"
                        style={{ fontSize: 10, paddingLeft: 5 }}
                      >
                        {"( " + option.name + " )"}
                      </label>
                    </div>
                  </React.Fragment>
                )}
                onChange={(event, value) => {
                  if (value) {
                    var data = [];
                    for (var i of value) {
                      data.push(i.value);
                    }
                    this.setState({
                      business_no_ids: value,
                      business_no_id: data,
                    });
                  } else {
                    this.setState({ business_no_id: [] });
                  }
                }}
                disableCloseOnSelect
                value={this.state.business_no_ids}
                name="Business_Number"
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Business No"
                    variant="standard"
                    style={{ top: 8 }}
                    fullWidth
                  />
                )}
                style={{ display: "contents" }}
              />
            </div>
            <div className="col-lg-3 pr-0 ml-1">
              <Autocomplete
                multiple
                options={this.state.documentation_agent_drop_value}
                getOptionLabel={(option) => option.name}
                renderOption={(option, { selected }) => (
                  <React.Fragment>
                    <Checkbox style={{ marginRight: 8 }} checked={selected} />
                    {option.name}
                  </React.Fragment>
                )}
                onChange={(event, value) => {
                  if (value) {
                    var data = [];
                    for (var i of value) {
                      data.push(i.value);
                    }
                    //var floating_crane_vendor = data.toString();
                    this.setState({ documentation_agent_ids: data });
                  } else {
                    this.setState({ documentation_agent_ids: [] });
                  }
                }}
                disableCloseOnSelect
                name="Documentation Charges"
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Documentation Agent"
                    label="Documentation Agent"
                    variant="standard"
                    style={{ top: 8 }}
                    fullWidth
                  />
                )}
                style={{ display: "contents" }}
              />
            </div>

            <div className="col p-2">
              <button
                className="header_button header_button_text add_button_adjustment"
                style={{ width: "auto", marginTop: "15px" }}
                onClick={() => this.searchBargeHandler()}
              >
                Load
              </button>
            </div>
            <div className="col p-2 text-right float-sm-left">
              {/* <a href={'/barge-pur-fin-add-doc'}><button className='header_button header_button_text add_button_adjustment' style={{ width: 'auto', marginTop: "17px" }}>New Costing</button></a> */}
              <button
                className="header_button header_button_text add_button_adjustment"
                style={{ width: "auto", marginTop: "15px" }}
                onClick={() =>
                  this.setState({ DocChargeAdd: true, showDrawer: true })
                }
              >
                New
              </button>
            </div>
          </div>

          {this.state.doc_costing_barges.length > 0 && (
            <div className="row">
              <div className="table-responsive">
                <table className="table table-bordered table-sm mb-0">
                  <thead className="table-header">
                    <tr>
                      <th nowrap="true" className=" text-uppercase "></th>
                      <th nowrap="true" className=" text-uppercase ">
                        Costing ID
                      </th>
                      <th nowrap="true" className=" text-uppercase ">
                        Barge ID
                      </th>
                      <th nowrap="true" className=" text-uppercase ">
                        Barge Nomination
                      </th>
                      <th nowrap="true" className=" text-uppercase ">
                        Business No
                      </th>
                      <th nowrap="true" className=" text-uppercase ">
                        Documentation Party
                      </th>
                      <th nowrap="true" className="text-right  text-uppercase ">
                        Quantity
                      </th>
                      <th nowrap="true" className="text-right  text-uppercase ">
                        Price PMT
                      </th>
                      <th nowrap="true" className="text-right  text-uppercase ">
                        Total Payable
                      </th>
                      <th nowrap="true" className="text-right  text-uppercase ">
                        Paid
                      </th>
                      <th nowrap="true" className="text-right  text-uppercase ">
                        Remaining
                      </th>
                    </tr>
                  </thead>
                  {this.state.doc_costing_barges.map((p, index) => (
                    <tbody key={index}>
                      <tr className="rounded">
                        <td className="text-center" nowrap="true">
                          <i
                            className="fa fa-eye mr-2"
                            aria-hidden="true"
                            style={{
                              fontSize: 22,
                              color: config.themeColor,
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              this.setState({
                                DocChargeView: true,
                                bargeCostingID: p.id,
                                showDrawer: true,
                              })
                            }
                          ></i>
                          {(this.state.features.includes("185") ||
                            this.state.features.includes("97")) &&
                            p.approval_status === "Pending" && (
                              <i
                                className="fa fa-trash-o"
                                aria-hidden="true"
                                style={{
                                  fontSize: 21,
                                  color: config.themeColor,
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  this.setState({
                                    deleteData: p,
                                    deleteCosting: true,
                                  })
                                }
                              ></i>
                            )}
                        </td>
                        <td className=" text-left" nowrap="true">
                          {p.costing_no}
                        </td>
                        <td className=" text-left">{pad(p.barge_id)}</td>
                        <td className=" text-left" nowrap="true">
                          {p.barge_nomination}
                        </td>
                        <td className=" text-left" nowrap="true">
                          {p.business_no}
                        </td>
                        <td className=" text-left" nowrap="true">
                          {p.dc_documentation_party}
                        </td>
                        <td className=" text-right" nowrap="true">
                          {toLocaleString(p.barge_quantity)}
                        </td>
                        <td className=" text-right" nowrap="true">
                          {toLocaleString(p.price_per_mt)}
                        </td>
                        <td className=" text-right" nowrap="true">
                          {toLocaleString(p.total_payable)}
                        </td>
                        <td className=" text-right" nowrap="true">
                          {toLocaleString(p.paid)}
                        </td>
                        <td className=" text-right" nowrap="true">
                          {toLocaleString(p.Remaining_amount)}
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            </div>
          )}
          {/**
           *
           * Delete Payament Postings Conformation Modal
           *
           */}

          {this.state.deleteCosting && (
            <DeleteConfirmation
              open={this.state.deleteCosting}
              close={() => this.setState({ deleteCosting: false })}
              callbackFn={() =>
                this.delete_barge_pur_fin_doc_charges(this.state.deleteData)
              }
            />
          )}
        </div>
      );
    }
  }
}
